import api from "./apiClient";

const API_URL = process.env.VUE_APP_API_BASE_URL + '/api/v2/';

export default {
  async informe(data) {
    const response = await api.post(API_URL + "comisiones/informe", data);
    if (response.data) return response.data;
  },

  async detalle(data) {
    const response = await api.post(API_URL + "comisiones/detalle", data);
    if (response.data) return response.data;
  },

  async exportar(data) {
    return await api.post(API_URL + "comisiones/export", data, { responseType: "blob" });
  },
};
